import {DataJobTypes} from "domain/BaseEntity";
import $ from "jquery";
import {toJS} from "mobx";
import StringUtil from "utils/StringUtil";

import ValueChecker from "../model/ValueChecker";
import ValidationRuleBytes from "../rules/ValidationRuleBytes";
import UIUtil from "utils/UIUtils";

export default class ValidationUtil {
    public static resetAllChecked(args?: any): void {
        $('[data-value-rule]').each((index, element) => {
            const $element = $(element);

            const valueRule = $element.data("value-rule").split(",");
            const valueChecker = new ValueChecker(valueRule);
            valueChecker.setChecked(undefined);
        });
    }

    public static checkAll(args?: any): boolean {
        const targetElements = $('[data-value-rule]');
        let result = false;
        for (let i = 0; i < targetElements.length; i++) {
            const $element = $(targetElements[i]);

            const valueRule = $element.data("value-rule").split(",").filter(item => {
                return StringUtil.isNotEmpty(item);
            });
            const valueBytes = $element.data("value-bytes");


            const valueChecker = new ValueChecker(valueRule);
            valueChecker.setValue($element.val())

            if (valueBytes && Object.keys(valueBytes).length !== 0) {
                valueChecker.addRule(new ValidationRuleBytes(valueBytes));
            }
            const isValid = valueChecker.checkValid();
            $element.attr("aria-invalid", String(!isValid));
            if (!isValid) {
                $element.addClass("tf-error")
                if (!result && valueChecker.message) {
                    UIUtil.alert(valueChecker.message).then(() => {
                        $element.trigger("focus");
                    })
                }
                result = true;
            }
            else {
                $element.removeClass("tf-error")
            }
        }
        return result;
    }

    public static isNotEmpty(value: any) {
        if (!value) {
            return false;
        }

        if (typeof value === "boolean") {
            return true;
        }


        if (typeof value === "string") {
            return value.length > 0;
        }

        let jsValue;

        if (typeof value === "object") {
            jsValue = toJS(value);
        }

        if (Array.isArray(jsValue) !== true) {
            return StringUtil.isNotEmpty(value);
        }

        for (let i = 0; i < jsValue.length; i++) {
            if (jsValue[i].JOB_TYPES == null || jsValue[i].JOB_TYPES !== DataJobTypes.DELETE) {
                return true;
            }
        }

        return false;
    }
}
